import { Configuration, PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { config } from "../config";

let instance: PublicClientApplication | null = null;

export function buildMsal(): PublicClientApplication {
  if (instance) return instance;
  const { tenant_id, client_id } = config();
  const msalConfig: Configuration = {
    auth: {
      // placeholder keeps MSAL constructible before the app reg exists;
      // LoginPage shows a "not configured" notice in that case.
      clientId: client_id || "00000000-0000-0000-0000-000000000000",
      authority: `https://login.microsoftonline.com/${tenant_id || "organizations"}`,
      redirectUri: window.location.origin + "/auth-callback",
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        loggerCallback: (level, message) => {
          if (level <= LogLevel.Warning) console.warn("[msal]", message);
        },
      },
    },
  };
  instance = new PublicClientApplication(msalConfig);
  return instance;
}

export function apiScopes(): string[] {
  return [`api://${config().client_id}/access_as_user`];
}
